module.exports = __webpack_public_path__ + "static/media/miss_active.47cbd056.png";